import { motion, useScroll } from 'framer-motion';
import { useRef } from 'react';
import { WordsPullUpMultiStyle, ScrollAnimatedText } from '../components/AnimationComponents';

export const HeroSection = () => {
  const hygieneManRef = useRef(null);
  const hygieneWarriorRef = useRef(null);

  const { scrollYProgress: manProgress } = useScroll({
    target: hygieneManRef,
    offset: ['start 0.8', 'end 0.2']
  });

  const { scrollYProgress: warriorProgress } = useScroll({
    target: hygieneWarriorRef,
    offset: ['start 0.8', 'end 0.2']
  });

  const hygieneManText = "Hygiene Man represents our mission to create cleaner, safer, and healthier spaces for everyone. From schools and colleges to workplaces and institutions, he stands as a symbol of protection, cleanliness, and care.";
  
  const hygieneWarriorText = "The Hygiene Warriors are the heartbeat of our mission — protecting spaces, promoting health, and delivering cleanliness with pride. More than a team, The Hygiene Warriors are guardians of hygiene, working every day to build safer and healthier environments.";

  return (
    <section id="hero" className="min-h-screen py-12 md:py-20 px-4 md:px-8" data-testid="hero-section">
      <div className="max-w-6xl mx-auto">
        {/* Hygiene Man Section */}
        <div ref={hygieneManRef} className="py-8 md:py-12 lg:py-16 mb-12 md:mb-20">
          <p className="text-white text-center text-[10px] sm:text-xs font-bold mb-6 md:mb-8 tracking-widest uppercase drop-shadow" data-testid="hygiene-man-label">
            The Hygiene Man — your shield against germs.
          </p>
          
          <WordsPullUpMultiStyle
            segments={[
              { text: "Meet", className: "text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-normal text-white drop-shadow-lg" },
              { text: "the", className: "text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-normal text-white drop-shadow-lg" },
              { text: "Hygiene Man", className: "text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-normal text-[#87CEEB] drop-shadow-lg" }
            ]}
            containerClassName="text-center max-w-3xl mx-auto leading-[0.95] sm:leading-[0.9] mb-8 md:mb-12"
          />

          {/* Hygiene Man Image */}
          <div className="flex justify-center mb-8 md:mb-12">
            <motion.img
              initial={{ scale: 0.9, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              src="/images/hygiene-man.png"
              alt="Hygiene Man"
              className="w-full max-w-md h-auto"
              style={{ filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.5))' }}
              data-testid="hygiene-man-image"
            />
          </div>

          <ScrollAnimatedText
            text={hygieneManText}
            scrollProgress={manProgress}
            className="text-white text-xs sm:text-sm md:text-base text-center max-w-3xl mx-auto leading-relaxed drop-shadow"
          />
        </div>

        {/* Hygiene Warrior Section */}
        <div ref={hygieneWarriorRef} className="py-8 md:py-12 lg:py-16">
          <p className="text-white text-center text-[10px] sm:text-xs font-bold mb-6 md:mb-8 tracking-widest uppercase drop-shadow" data-testid="hygiene-warrior-label">
            The Hygiene Warrior.
          </p>
          
          <WordsPullUpMultiStyle
            segments={[
              { text: "The", className: "text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-normal text-white drop-shadow-lg" },
              { text: "Hygiene", className: "text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-normal text-[#87CEEB] drop-shadow-lg" },
              { text: "Warriors", className: "text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-normal text-[#90EE90] drop-shadow-lg" }
            ]}
            containerClassName="text-center max-w-3xl mx-auto leading-[0.95] sm:leading-[0.9] mb-8 md:mb-12"
          />

          <ScrollAnimatedText
            text={hygieneWarriorText}
            scrollProgress={warriorProgress}
            className="text-white text-xs sm:text-sm md:text-base text-center max-w-3xl mx-auto leading-relaxed drop-shadow"
          />
        </div>
      </div>
    </section>
  );
};
